import { createContext } from 'react';
import type { Language } from '../i18n/types';

/**
 * 语言上下文值接口
 */
export interface LanguageContextValue {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string) => string;
}

/**
 * 语言上下文
 */
export const LanguageContext = createContext<LanguageContextValue | undefined>(undefined);
